<template>
  <h2>{{ data.title_section }}</h2>
  <div class="go1-grid">
    <div
      class="md:go1-col-6 lg:go1-col-4 go1-col-12"
      v-for="(paquete, index) in paquetes"
      :key="index"
    >
      <a :href="paquete.url" class="go1-paquetes">
        <div
          class="go1-imagen go1-flex"
          :style="'background-image: url(' + `${paquete.image}` + ')'"
        >
          <div
            class="go1-flex go1-flex-column go1-justify-content-between"
            style="width: 100%"
          >
            <div class="go1-flex go1-justify-content-start">
              <div
                v-if="paquete.quote.paqueteDiscount"
                class="go1-ribbon go1-hotel-pla-principal"
              >
                <div class="go1-hotel-text-pla-principal go1-pl-2">
                  {{ paquete.quote.paqueteDiscount }}%
                  {{ $t("message.descuento") }}
                </div>
                <i class="go1-icon go1-hotel-icons fas fa-plane"></i>
                <i class="go1-icon go1-hotel-icons fas fa-hotel"></i>
              </div>
            </div>
            <div
              class="go1-paquetes-gradient go1-flex go1-justify-content-start"
            >
              <div class="go1-hotel-bottom">
                <div
                  class="go1-grid go1-grid-nogutter go1-justify-content-end go1-z-3"
                >
                  <div class="go1-col-auto go1-align-self-center">
                    <div
                      style="text-shadow: 0 2px 3px rgba(0, 0, 0, 0.3)"
                      class="go1-hotel-title-origin go1-block go1-text-right go1-text-overflow-elipsis go1-text-xl"
                    >
                      {{ paquete.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="go1-contenido">
          <div class="go1-grid go1-grid-nogutter">
            <div class="go1-col-4">
              <div
                class="go1-hotel-bg-promotion go1-hotel-text-promotion go1-h-full go1-flex go1-flex-column go1-justify-content-end"
                style="box-sizing: border-box;"
              >
                <div class="go1-text-right go1-text-right go1-pr-2 go1-pb-3">
                  <span class="text-responsive">{{
                    $t("message.total_desde")
                  }}</span>
                  <span
                    v-if="paquete.quote.discount"
                    class="go1-text-translucent go1-py-1 go1-line-through text-responsive"
                  >
                    <PriceLabel
                      :value="[
                        paquete.quote.paquetePreTotal,
                        paquete.quote.currency,
                      ]"
                    ></PriceLabel>
                  </span>

                  <span
                    :class="{
                      'small-text-2': paquete.quote.currency === 'COP',
                      'small-text-3': paquete.quote.currency !== 'COP',
                      'go1-py-1': paquete.quote.currency !== 'COP',
                    }"
                    style="display: block; width: 100%"
                  >
                    <PriceLabel
                      :value="[
                        paquete.quote.paqueteTotal,
                        paquete.quote.currency,
                      ]"
                    ></PriceLabel>
                  </span>
                </div>
              </div>
            </div>
            <div class="go1-col-8">
              <div class="go1-grid go1-grid-nogutter go1-pl-2 go1-py-2">
                <div class="go1-col-fixed go1-fixed-icons">
                  <i class="fas fa-map-marker-alt go1-hotel-icons"></i>
                </div>
                <div class="go1-col text-responsive">
                  {{ $t("message.saliendo") }}:
                  {{
                    data.origin?.displayText.replace(
                      /^[A-Z]{3}\s([^,]+).+/,
                      "$1"
                    )
                  }}
                </div>
                <div class="go1-col-12">
                  <hr />
                </div>
                <div class="go1-col-fixed go1-fixed-icons">
                  <i class="go1-icon go1-hotel-icons fas fa-bed"></i>
                </div>
                <div class="go1-col text-responsive">
                  <div>
                    {{ $t("message.from") }}:
                    <span class="go1-hotel-text">
                      <FechaLabel :value="fecha1"></FechaLabel>
                    </span>
                  </div>
                  <div>
                    {{ $t("message.to") }}:
                    <span class="go1-hotel-text">
                      <FechaLabel :value="fecha2"></FechaLabel>
                    </span>
                  </div>
                </div>
                <div class="go1-col-12">
                  <hr />
                </div>
                <div class="go1-col-fixed go1-fixed-icons">
                  <i class="go1-icon go1-hotel-icons fas fa-user-friends"></i>
                </div>
                <div class="go1-col go1-hotel-text">
                  {{ $t("message.personas", data.number_pax) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
<script setup>
const { data } = defineProps(["data"]);

import PriceLabel from "@/components/extra/PriceLabel";
import EstrellasLabel from "@/components/extra/EstrellasLabel";
import FechaLabel from "@/components/extra/FechaLabel";
import { useI18n } from "vue-i18n";
import { SortType } from "@/components/extra/Sort.ts";

const { t } = useI18n({ useScope: "global" });

function obtenerProximoDia(fecha, dia) {
  var diaSemana = fecha.getDay();
  var diferenciaDias = dia - diaSemana; // Diferencia de días para llegar al próximo lunes
  if (diferenciaDias < 0) {
    diferenciaDias += 7; // Si el día actual es lunes, sumamos una semana completa
  }
  fecha.setDate(fecha.getDate() + diferenciaDias);
  return fecha;
}

let fecha1;
let fecha2;
if (data.date_type == "Personalizada") {
  fecha1 = new Date(data.date_start);
  if (data.day_start) {
    fecha1 = obtenerProximoDia(fecha1, data.day_start);
  }
  fecha2 = new Date(data.date_end);
} else if (data.date_type == "Dinamica") {
  let now = new Date();
  fecha1 = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + data.days_future
  );
  if (data.day_start) {
    fecha1 = obtenerProximoDia(fecha1, data.day_start);
  }
  fecha2 = new Date(
    fecha1.getFullYear(),
    fecha1.getMonth(),
    fecha1.getDate() + data.nights
  );
}

let fechaInicio = fecha1
  .toISOString()
  .replace(/\d\d(\d\d)-(\d\d)-(\d\d).+/, "$2/$3/$1");
let fechaFin = fecha2
  .toISOString()
  .replace(/\d\d(\d\d)-(\d\d)-(\d\d).+/, "$2/$3/$1");

let fecha1H = fecha1
  .toISOString()
  .replace(/(\d\d\d\d)-(\d\d)-(\d\d).+/, "$1-$2-$3");
let fecha2H = fecha2
  .toISOString()
  .replace(/(\d\d\d\d)-(\d\d)-(\d\d).+/, "$1-$2-$3");

let hotelIds = data.selected_hotels.map((el) => el.code);
let blockSize = 10;
let bloquesIds = hotelIds.reduce((acc, _, i) => (i % blockSize) ? acc : [...acc, hotelIds.slice(i, i + blockSize)], []);
let hotels = [];

let precios = {};
for (let hotelIds of bloquesIds) {
  let url =
    window.apiUri +
    "/api/quote/hotels?ChannelId=" +
    config.id +
    "&Currency=" +
    config.currency +
    "&Language=" +
    config.languageId +
    "&AffiliateSiteId=" +
    config.affiliateSiteId +
    "&Ids=" +
    hotelIds +
    "&Paxes=" +
    data.number_pax +
    "&IsPackage=true" +
    "&ArrivalDate=" +
    fechaInicio +
    "&DepartureDate=" +
    fechaFin;

  let response = await fetch(url);
  let { rates } = await response.json();
  precios = {...rates,...precios};
}
//vuelos
let iatas = {};
let airline = "";
if (data.airline && data.airline.code) {
  airline = data.airline.code;
}
for (const item of data.selected_hotels) {
  let quote = precios[item.code];
  if (quote) {
    let hotel = item;
    hotel.quote = quote;
    hotels.push(hotel);
  }
}

//agregar iata de destino extraído de la API o del Hotel.
let destination = data.destination;
if (destination) 
{
  iatas[destination.code] = false;
}
else
{
  hotels.forEach( hotel =>
  {
    if(hotel.iata)
    {
      iatas[hotel.iata] = false;
    }
  })
}

var url2 =
  window.apiUri +
  "/api/quote/flights?ChannelId=" +
  config.id +
  "&Currency=" +
  config.currency +
  "&Language=" +
  config.languageId +
  "&AffiliateSiteId=" +
  config.affiliateSiteId +
  "&Departure=" +
  data.origin.code +
  "&Paxes=" +
  data.number_pax +
  "&ArrivalDate=" +
  fechaFin +
  "&DepartureDate=" +
  fechaInicio +
  "&Airline=" +
  airline;

for (const iata in iatas) {
  try {
    let urlv = url2 + "&Arrival=" + iata;
    let res = await fetch(urlv);
    let { response } = await res.json();
    iatas[iata] = response;
  } catch (error) {
    console.log(error);
  }
}

let paquetes = [];
let base = window.domain;
if (window.config.uri) {
  base = base + "/" + window.config.uri;
}
let action_url = base + "/" + t("url.paquetes");

action_url += `?CheckIn=${fecha1H}&CheckOut=${fecha2H}&CustomAirportCode=${data.origin.code}&PackageType=0&IsQuote=true&modal=true&Rooms=1&room0.Adults=${data.number_pax}&room0.AgeKids=&room0.Kids=0`;

for (let hotel of hotels) {
  
  let flight = (destination) ? iatas[destination.code] : iatas[hotel.iata];

  if (flight && flight.recommendations) {
    let recommendation = Object.values(flight.recommendations)[0];
    if (recommendation) {
      let vuelo = recommendation.fareCombinables[0].totalFare.amount;
      let preTotal = vuelo + hotel.quote.prePromotionalRateWithTaxes;
      let total = vuelo + hotel.quote.amountTotal;
      let discount = Math.round((1 - total / preTotal) * 100);
      let paquete = hotel;
      paquete.url =
        action_url +
        `&idHotel=${hotel.code}&hotel=${hotel.code}`;
      
      if (destination)
      {
        paquete.url += `&CustomDestinationAirportCode=${destination.code}`;
        paquete.url += `&MappingType=0MappingId=0&MappingCode=`;
      }
      else
      {
        paquete.url += `&MappingType=1&MappingId=${hotel.quote.destinationId}`;
      }

      paquete.quote.paqueteTotal = total;
      paquete.quote.paqueteDiscount = discount;
      paquete.quote.paquetePreTotal = preTotal;
      paquetes.push(paquete);
    }
  }
}
if (typeof data.sort == "object") {
  switch (data.sort.id) {
    case SortType.Stars:
      paquetes = paquetes.sort((a, b) => b.stars - a.stars);
      break;
    case SortType.High:
      paquetes = paquetes.sort((a, b) => b.quote.paqueteTotal - a.quote.paqueteTotal);
      break;
    case SortType.Low:
      paquetes = paquetes.sort((a, b) => a.quote.paqueteTotal - b.quote.paqueteTotal);
      break;
    default:
      break;
  }
} else {
  if (data.sort == SortType.Price) {
    paquetes = paquetes.sort((a, b) => a.quote.paqueteTotal - b.quote.paqueteTotal);
  }
}
</script>

<style>
/*DATA STYLES CLASSES*/
.render .go1-paquetes .go1-hotel-pla-principal {
  background-color: v-bind("#" + data.styles.bg_pla_principal);
  color: v-bind("#" + data.styles.c_pla_principal);
}

.render .go1-paquetes .go1-hotel-icons {
  color: v-bind("#" + data.styles.c_icons);
}

.render .go1-paquetes .go1-hotel-title-origin {
  color: v-bind("#" + data.styles.c_title_origin);
}

.render .go1-paquetes .go1-hotel-bg-promotion {
  background-color: v-bind("#" + data.styles.bg_promotion);
}

.render .go1-paquetes .go1-hotel-text-promotion {
  color: v-bind("#" + data.styles.c_promotion);
}

.render .go1-paquetes .go1-hotel-text {
  color: v-bind("#" + data.styles.c_text);
}

.small-text {
  font-size: 1.2em; /* Ajusta el tamaño de la fuente según sea necesario */
}
.small-text-2 {
  font-size: 1.3em; /* Ajusta el tamaño de la fuente según sea necesario */
}
.small-text-3 {
  font-size: 1.6em; /* Ajusta el tamaño de la fuente según sea necesario */
}
.small-text-4 {
  font-size: 1.5em; /* Ajusta el tamaño de la fuente según sea necesario */
}
.render .go1-paquetes-gradient {
  background: rgba(
    v-bind("data.styles.c_gradient?.r || '100'"),
    v-bind("data.styles.c_gradient?.g || '150'"),
    v-bind("data.styles.c_gradient?.b || '200'"),
    v-bind("data.styles.c_alpha || '0.8'")
  ) !important;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
</style>
